import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { raceCancellation } from 'vscode/vscode/vs/base/common/async';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { Disposable, toDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { insert } from 'vscode/vscode/vs/base/common/arrays';

let TextFileSaveParticipant = class TextFileSaveParticipant extends Disposable {
    constructor(logService) {
        super();
        this.logService = logService;
        this.saveParticipants = [];
    }
    addSaveParticipant(participant) {
        const remove = insert(this.saveParticipants, participant);
        return toDisposable(() => remove());
    }
    async participate(model, context, progress, token) {
        model.textEditorModel?.pushStackElement();
        for (const saveParticipant of this.saveParticipants) {
            if (token.isCancellationRequested || !model.textEditorModel ) {
                break;
            }
            try {
                const promise = saveParticipant.participate(model, context, progress, token);
                await raceCancellation(promise, token);
            }
            catch (err) {
                this.logService.error(err);
            }
        }
        model.textEditorModel?.pushStackElement();
    }
    dispose() {
        this.saveParticipants.splice(0, this.saveParticipants.length);
        super.dispose();
    }
};
TextFileSaveParticipant = ( __decorate([
    ( __param(0, ILogService))
], TextFileSaveParticipant));

export { TextFileSaveParticipant };
